import { Action } from 'redux';
import { DisplayableFile } from 'src/app/angular-elements/form-wrappers/form-components/required-docs-upload/interfaces/displayable-file.interface';
import { LifeEventDocumentUpload, LifeEventStateStructure } from '../interfaces/life-event.state-structure.interface';

export const LIFE_EVENT_DOCUMENT_UPLOAD_REDUCER = 'LifeEvent';

/** INITIAL STATE */
export const INITIAL_STATE: LifeEventStateStructure = {
  documents: [],
  isDocumentUploadRequired: false,
  minRequired: 0
};


/** ACTION TYPES */
const SET_DOCUMENT = 'SET_DOCUMENT';
const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT';
const RESET_DOCUMENTS = `RESET_DOCUMENTS_${LIFE_EVENT_DOCUMENT_UPLOAD_REDUCER}`;
const STORE_LIFE_EVENT_DOCUMENT_UPLOAD_STATE = 'STORE_LIFE_EVENT_DOCUMENT_UPLOAD_STATE';
const SET_DOCUMENT_UPLOAD_REQUIRED_FLAG = 'SET_DOCUMENT_UPLOAD_REQUIRED_FLAG';

/** ACTION INTERFACE */
export class LifeEventAction implements Action {
  type: string;
  displayableFileObj?: DisplayableFile;
  documentcontrolnumber?: string;
  doctype?: string; // this comes from uploading SEP documentation and selecting a document from a customDropdownSelection 
  state?: LifeEventStateStructure;

  isDocumentUploadRequired?: boolean;
  minRequired?: number | null;
}

export function setSEPLifeEventDocumentInfo(displayableFileObj: DisplayableFile, doctype?: string): LifeEventAction {
  return { type: SET_DOCUMENT, displayableFileObj, doctype };
}
export function removeSEPLifeEventDocumentInfo(documentcontrolnumber: string): LifeEventAction {
  return { type: REMOVE_DOCUMENT, documentcontrolnumber: documentcontrolnumber };
}
export function resetSEPLifeEventDocumentInfo(): LifeEventAction {
  return { type: RESET_DOCUMENTS };
}
export function storeLifeEventDocumentUploadState(state: LifeEventStateStructure): LifeEventAction {
  return { type: STORE_LIFE_EVENT_DOCUMENT_UPLOAD_STATE, state }
}
export function setIsDocumentUploadRequired(data: {
  isDocumentUploadRequired: boolean,
  minRequired: number | null
}): LifeEventAction {
  return { type: SET_DOCUMENT_UPLOAD_REQUIRED_FLAG, isDocumentUploadRequired: data.isDocumentUploadRequired, minRequired: data.minRequired };
}
/** REDUCER */
export function LifeEvent(state: LifeEventStateStructure = INITIAL_STATE, action: LifeEventAction) {
  const copiedState: LifeEventStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SET_DOCUMENT:
      
      const item: LifeEventDocumentUpload = {
        displayableFileObj: action.displayableFileObj
      };

      if (action.doctype) {
        item.doctype = action.doctype;
      }

      copiedState.documents.push(item);
      return Object.assign({}, state, copiedState);
    case REMOVE_DOCUMENT:
      copiedState.documents = copiedState.documents.filter(document => document.displayableFileObj.documentRecord !== action.documentcontrolnumber);
      return Object.assign({}, state, copiedState);
    case RESET_DOCUMENTS:
      copiedState.documents = INITIAL_STATE.documents;
      return Object.assign({}, state, copiedState);
    case STORE_LIFE_EVENT_DOCUMENT_UPLOAD_STATE:
      return Object.assign({}, state, action.state);
    case SET_DOCUMENT_UPLOAD_REQUIRED_FLAG:
      copiedState.isDocumentUploadRequired = action.isDocumentUploadRequired;
      copiedState.minRequired = action.minRequired;
      return Object.assign({}, state, copiedState);
    
    default:
      return state;
  }
}
